import App from './App.svelte';
import webOSTVJS from "./webOSTVjs-1.1.0/webOSTV"
import webOSTVJSDev from "./webOSTVjs-1.1.0/webOSTV-dev"

const app = new App({
	target: document.body
});

export default app;
